export default "__VITE_PUBLIC_ASSET__cd79e7c5__"